import React from "react";
import PropTypes, { element } from "prop-types";
import { withStyles } from "@material-ui/core";
import { AdminContextConsumer } from "../pages/Admin"
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Button from "@material-ui/core/Button/Button";
import gql from 'graphql-tag';
import * as graphql from '../common/graphql';
import Message from "./Message";
import { withIAM, isInRoles, ROLE_ADMIN, ROLE_READER, ROLE_OWNER, ROLE_ASSISTANT, ROLE_EDITOR } from "../common/iam";
import * as i18n from "../common/i18n";
import ResponsiveContainer from 'recharts/lib/component/ResponsiveContainer';
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell
} from 'recharts';
import Skeleton from '@material-ui/lab/Skeleton';

const defaultData = {
    total: {
        totalCount: 0
    },
    leased: {
        totalCount: 0
    },
    stocked: {
        totalCount: 0
    },
    maintenance: {
        totalCount: 0
    },
    defective: {
        totalCount: 0
    },
    late: {
        totalCount: 0
    },
    alerts: {
        totalCount: 0
    }
}

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    head: {
        display: "flex",
        justifyContent: "center",
        alignItems: "baseline"
    },
    header: {
        margin: theme.spacing(5)
    },
    formControl: {
        margin: theme.spacing(),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
});

class Dashboard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            chartLoading: true,
            findingsChartLoading: true,
            findingsData: [],
            data: defaultData,
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
        };
    }

    showMessage = (message, variant, details, hideAfter) => {
        this.setState({
            message: message,
            variant: variant ? variant : "info",
            hideAfter: hideAfter ? hideAfter : 3000,
            details: details ? details : null,
        })
    }

    closeMessage = () => {
        this.setState({
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
        })
    }

    componentDidMount() {
        this.setState({
            loading: false
        });
        this.fetchDeviceStatus()
    }

    DevicesBarChart = (props, onLink) => {
        const { data } = props;

        const devices = data.alerts.elements.map(element => element.device.uuid)
        const uniqDevices = devices.filter((x, i) => i === devices.indexOf(x))

        const devicesData = [
            { name: 'Geräte insgesamt', Anzahl: data.total.totalCount },
            { name: 'Vermietete Geräte', Anzahl: data.leased.totalCount },
            { name: 'Geräte im Lager', Anzahl: data.stocked.totalCount },
            { name: 'Geräte in Reparatur', Anzahl: data.maintenance.totalCount },
            { name: 'Geräte in Montage', Anzahl: data.assembly.totalCount },
            { name: 'Defekte Geräte', Anzahl: data.defective.totalCount },
            { name: 'Überfällige Geräte', Anzahl: data.late.totalCount },
            // { name: 'Offene Alarme', Anzahl: data.alerts.totalCount },
            { name: 'Geräte mit Alarmen', Anzahl: uniqDevices.length },
        ];

        const COLORS = ['#82ca9d', '#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#ec0101', '#7B241C'];

        return (
            <AdminContextConsumer>
                {({ onLinkWithData }) => (
                    <ResponsiveContainer width="99%" height={320}>
                        <BarChart
                            width={600}
                            height={300}
                            data={devicesData}
                            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                            onClick={(data) => {
                                // this.handleDeviceChartClick(data.activeTooltipIndex)
                                let menu, pageData;
                                switch (data.activeTooltipIndex) {
                                    case 0:
                                        menu = 'menus.devices'
                                        pageData = null
                                        break;

                                    case 1:
                                        menu = 'menus.devices'
                                        pageData = { status: ['LEASED'] }
                                        break;

                                    case 2:
                                        menu = 'menus.devices'
                                        pageData = { status: ['STOCKED'] }
                                        break;

                                    case 3:
                                        menu = 'menus.devices'
                                        pageData = { status: ['MAINTENANCE'] }
                                        break;

                                    case 4:
                                        menu = 'menus.devices'
                                        pageData = { status: ['ASSEMBLY'] }
                                        break;

                                    case 5:
                                        menu = 'menus.devices'
                                        pageData = { status: ['DEFECTIVE'] }
                                        break;

                                    case 6:
                                        menu = 'menus.lateDevices'
                                        pageData = null
                                        break;
                                        
                                    case 7:
                                        menu = 'menus.alerts'
                                        pageData = null
                                        break;

                                }
                                onLinkWithData(i18n.get(menu), pageData)
                            }} >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis type="number" domain={[0, data.total.totalCount]} />
                            <Tooltip />
                            <Bar dataKey="Anzahl" fill="#82ca9d" >
                                {
                                    devicesData.map((entry, index) => {
                                        const color = COLORS[index];
                                        return <Cell fill={color} />;
                                    })
                                }
                            </Bar>

                        </BarChart>
                    </ResponsiveContainer>
                )}
            </AdminContextConsumer>
        );
    }

    fetchDeviceStatus = async () => {
        try {
            const result = await graphql.clientWithToken(this.props.accessToken).query({
                query: gql`
            query {
                total: devices {
                    totalCount
                }
                leased: devices(
                    where: [{ column: "status", comparator: IS, string: "LEASED" }]

                ) {
                    totalCount
                }
                stocked: devices(
                    where: [{ column: "status", comparator: IS, string: "STOCKED" }]
                ) {
                    totalCount
                }
                maintenance: devices(
                    where: [{ column: "status", comparator: IS, string: "MAINTENANCE" }]
                ) {
                    totalCount
                }
                defective: devices(
                    where: [{ column: "status", comparator: IS, string: "DEFECTIVE" }]
                ) {
                    totalCount
                }
                assembly: devices(
                    where: [{ column: "status", comparator: IS, string: "ASSEMBLY" }]
                ) {
                    totalCount
                }
                late: findings(
                    subject: LATE_DEVICES
                ) {
                    totalCount
                }
                alerts: alerts (
                    first: 200
                    where: [{ column: "status", comparator: IS, string: "NEW" }]
                ) {
                    totalCount
                    elements {
                        ... on Alert {
                            device {
                                uuid
                            }
                        }
                    }
                }
            }`,
                fetchPolicy: "no-cache"
            });

            const searchResult = {
                data: result.data
            }

            this.handleDeviceStatusChange(searchResult);
        }
        catch (error) {
            this.showMessage(error.message, "error");
        }
    }

    handleDeviceStatusChange = async (deviceCounters) => {
        this.setState({
            chartLoading: false,
            data: deviceCounters.data
        })

    }

    render() {

        const { classes } = this.props;

        return (
            <React.Fragment>
                {this.state.loading ? <div /> : (

                    <AdminContextConsumer>
                        {({ onLink }) => (

                            <React.Fragment>

                                <Typography variant={"h5"} className={classes.header} align={"center"}>{i18n.get("dashboard.nextSteps")}</Typography>

                                {this.state.chartLoading ?
                                    <React.Fragment>
                                        <Skeleton variant="rect" width='99%' height={320} />
                                    </React.Fragment>
                                    :
                                    <React.Fragment>
                                        <this.DevicesBarChart data={this.state.data} onLink={onLink} />
                                    </React.Fragment>
                                }

                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={4}>
                                        <Card>
                                            <CardContent>
                                                <Typography variant="h5" component="h2">
                                                    {i18n.get("dashboard.grid.1.h2")}
                                                </Typography>
                                                <Typography component="p">
                                                    {i18n.get("dashboard.grid.1.p")}
                                                </Typography>
                                            </CardContent>
                                            <CardActions>
                                                <Button size="small" onClick={e => onLink(parseInt(i18n.get("dashboard.grid.1.button.menuIndex")), parseInt(i18n.get("dashboard.grid.1.button.entriesIndex")))}>{i18n.get("dashboard.grid.1.button")}</Button>
                                            </CardActions>
                                        </Card>
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <Card>
                                            <CardContent>
                                                <Typography variant="h5" component="h2">
                                                    {i18n.get("dashboard.grid.2.h2")}
                                                </Typography>
                                                <Typography component="p">
                                                    {i18n.get("dashboard.grid.2.p")}
                                                </Typography>
                                            </CardContent>
                                            <CardActions>

                                                <Button size="small" onClick={e => onLink(parseInt(i18n.get("dashboard.grid.2.button.menuIndex")), parseInt(i18n.get("dashboard.grid.2.button.entriesIndex")))}>{i18n.get("dashboard.grid.2.button")}</Button>
                                            </CardActions>
                                        </Card>
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <Card className={classes.card}>
                                            <CardContent>
                                                <Typography variant="h5" component="h2">
                                                    {i18n.get("dashboard.grid.3.h2")}
                                                </Typography>
                                                <Typography component="p">
                                                    {i18n.get("dashboard.grid.3.p")}
                                                </Typography>
                                            </CardContent>
                                            <CardActions>
                                                <Button size="small" onClick={e => onLink(parseInt(i18n.get("dashboard.grid.3.button.menuIndex")), parseInt(i18n.get("dashboard.grid.3.button.entriesIndex")))}>{i18n.get("dashboard.grid.3.button")}</Button>
                                            </CardActions>
                                        </Card>
                                    </Grid>

                                </Grid>

                            </React.Fragment>
                        )}
                    </AdminContextConsumer>

                )}

                <Message
                    hideAfter={this.state.hideAfter}
                    onClose={this.closeMessage}
                    variant={this.state.variant}
                    message={this.state.message}
                    details={this.state.details}
                    open={this.state.message !== null}
                />

            </React.Fragment>
        )
    }
}

Dashboard.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withIAM(withStyles(styles, { withTheme: true })(Dashboard))